import request from '@/utils/request'


/**
 * 修改能量链信息
 * @param {*} elink
 * @returns
 */
export function updateElink(elink) {
  return request({
    url: '/device/elink',
    method: 'put',
    data: elink
  })
}

/**
 * 新增能量链信息
 * @param {*} elink
 * @returns
 */
export function addElink(elink) {
  return request({
    url: '/device/elink',
    method: 'post',
    data: elink
  })
}

/**
 * 获取设备详细信息
 * @param {*} equipmentId
 * @returns
 */
export function getElink(equipmentId) {
  return request({
    url: '/device/elink/' + equipmentId,
    method: 'get',
  })
}

/**
 * 批量删除能量链
 * @param {*} equipmentIds
 * @returns
 */
export function delElink(equipmentIds) {
  return request({
    url: '/device/elink/' + equipmentIds,
    method: 'delete',
  })
}


/**
 * 根据电站ID获取所有elink和eblock的对应关系
 * @param {*} stationId
 * @returns
 */
export function getElinkStruct(stationId) {
  return request({
    url: '/device/elink/eLinkList/' + stationId,
    method: 'get',
  })
}


/**
 * 导出设备列表
 * @returns
 */
export function exportDevice() {
  return request({
    url: '/device/elink/export',
    method: 'get',
  })
}


/**
 * 导入能量链基本信息
 * @returns
 */
export function importData() {
  return request({
    url: '/device/elink/importData',
    method: 'post',
  })
}


/**
 * 获取导入数据模板
 * @returns
 */
export function importTemplate() {
  return request({
    url: '/device/elink/importTemplate',
    method: 'get',
  })
}


/**
 * 获取能量链列表
 * @param {*} pageNum
 * @param {*} pageSize
 * @param {*} stationId
 * @returns
 */
export function getElinkList(pageNum, pageSize, stationId, unitId) {
  return request({
    url: '/device/elink/list',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      stationId,
      unitId
    }
  })
}

export function queryELink(pageNum, pageSize, equipmentId, uuid, stationName, /* productModel, */ emqxClientId) {
  return request({
    url: '/device/elink/list',
    method: 'get',
    params: {
      pageNum,
      pageSize,
      equipmentId,
      uuid,
      stationName,
      // productModel,
      emqxClientId
    }
  })
}


